<template>
  <div class="bg-white rounded-2xl shadow-md p-6 space-y-4">
    <div class="flex items-center justify-between">
      <h2 class="text-lg font-bold">Informations générales</h2>
      <StoreConfigurationStatusBadge :configuration-status="store.generalInformationsConfigStatus" />
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-4">
      <StackedField label="Raison sociale">
        <FormField id="businessName" name="businessName" v-model="formData.businessName" required />
      </StackedField>
      <StackedField label="Nom commercial">
        <FormField id="salesChannel" name="salesChannel" v-model="formData.salesChannel" required />
      </StackedField>
      <StackedField label="Adresse postale">
        <LocationField id="shippingAddress" placeholder="Adresse postale" v-model="formData.shippingAddress" required />
      </StackedField>
      <StackedField label="Adresse de facturation">
        <FormField id="billingAddress" name="billingAddress" v-model="formData.billingAddress" required />
      </StackedField>
      <StackedField label="CA du magasin">
        <Selector
          id="revenueRange"
          name="revenueRange"
          v-model="formData.revenueRange"
          :options="revenueRangeOptions"
          required
        />
      </StackedField>
      <StackedField label="Type d'exploitation">
        <Selector
          id="ownershipType"
          name="ownershipType"
          v-model="formData.ownershipType"
          :options="ownershipTypeOptions"
          required
        />
      </StackedField>
    </div>
    <div class="flex justify-end gap-x-3">
      <SecondaryButton @click="submit" :loading="saving">Continuer</SecondaryButton>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { StackedField, FormField, Selector, LocationField, SecondaryButton } from "@estaly/ui";
import StoreConfigurationStatusBadge from "@/components/StoreConfigurationStatusBadge.vue";

export default {
  name: "StoreOnboardingStepGeneralInfo",
  components: { StackedField, FormField, Selector, LocationField, SecondaryButton, StoreConfigurationStatusBadge },
  props: { store: { type: Object, required: true } },
  emits: ["step-completed"],
  data() {
    return {
      saving: false,
      formData: {
        businessName: this.store.businessName || "",
        salesChannel: this.store.salesChannel || "",
        shippingAddress: this.store.shippingAddress || "",
        billingAddress: this.store.billingAddress || "",
        revenueRange: this.store.revenueRange || "",
        ownershipType: this.store.ownershipType || "",
      },
    };
  },
  computed: {
    ...mapGetters("stores", ["getRevenueRanges", "getOwnershipTypes"]),
    revenueRangeOptions() {
      return this.getRevenueRanges().map((r) => ({
        value: r,
        label: this.$t(`organization.revenue_range.${r}`),
      }));
    },
    ownershipTypeOptions() {
      return this.getOwnershipTypes().map((o) => ({
        value: o,
        label: this.$t(`store.ownership_type.${o}`),
      }));
    },
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("stores", ["updateGeneralInformations"]),
    async submit() {
      this.saving = true;
      const response = await this.updateGeneralInformations({
        storeId: this.store.id,
        ...this.formData,
      });
      this.saving = false;
      if (!response?.success) return;

      await this.notify({ category: "simple", type: "success", title: "Informations générales enregistrées" });
      this.$emit("step-completed");
    },
  },
};
</script>
